import script from "./ResetFilterButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetFilterButton.vue?vue&type=script&setup=true&lang=js"

import "./ResetFilterButton.vue?vue&type=style&index=0&id=6ab4a94b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab4a94b"]])

export default __exports__